import { eventChannel } from 'redux-saga';
import { put, select, take } from 'redux-saga/effects';
import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';
import * as actions from '../state';
import bugsnagClient from '../bugsnag';

const messages = defineMessages({
  NETWORK_LOST_CONNECTION_TOAST: {
    id: 'NETWORK_LOST_CONNECTION_TOAST',
    defaultMessage: 'Lost connection. Trying to reconnect...',
  },
  NETWORK_NO_CONNECTION_TOAST: {
    id: 'NETWORK_NO_CONNECTION_TOAST',
    defaultMessage: 'No connection. Trying to reconnect...',
  },
});

const _sendError = (message) => {
  // the loop handles offline cases
  // the error will send after the browser is back online
  const interval = setInterval(() => {
    if (navigator.onLine) {
      bugsnagClient.notify(new Error(message));
      clearInterval(interval);
    }
  }, 10000);
};

// eslint-disable-next-line import/prefer-default-export
export function* networkConnection() {
  const channel = eventChannel((emitter) => {
    let lastState = null;

    const interval = setInterval(() => {
      if (lastState !== navigator.onLine) {
        lastState = navigator.onLine;
        emitter(lastState);
      }
    }, 1000);

    // unsubscribe method
    return () => {
      clearInterval(interval);
    };
  });

  while (true) {
    const res = yield take(channel);
    yield put(actions.setNetworkConnected(res));
    if (res === false) {
      _sendError('Network connection error');

      const lastState = yield select((state) => actions.selectNetworkConnected(state));

      let msg;
      if (lastState === null) {
        msg = messages.NETWORK_NO_CONNECTION_TOAST;
      } else {
        msg = messages.NETWORK_LOST_CONNECTION_TOAST;
      }

      yield put(actions.showToaster({
        show: true,
        message: <FormattedMessage {...msg} />,
        type: 'error',
      }));
    }
  }
}
